import {
    createBaseThemeOptions,
    createUnifiedTheme, defaultTypography,
    genPageTheme,
    palettes,
} from '@backstage/theme';

import breeShHeadlingRegular from '../assets/fonts/Bree-SH-Headline-Regular.woff';
import sisan03 from '../assets/fonts/sisan03.woff';
import sisan08 from '../assets/fonts/sisan08.woff';
import sisan33 from '../assets/fonts/sisan33.woff';

const siemensSans03Font = {
    fontFamily: 'siemens sans',
    fontStyle: 'normal',
    fontWeight: '500',
    src: `url(${sisan03}) format('woff')`
};

const siemensSans33Font = {
    fontFamily: 'siemens sans',
    fontStyle: 'italic',
    fontWeight: '500',
    src: `url(${sisan33}) format('woff')`
};
const siemensSans08Font = {
    fontFamily: 'siemens sans',
    fontStyle: 'normal',
    fontWeight: '900',
    src: `url(${sisan08}) format('woff')`
};

const breeShHeadlineRegularFont = {
    fontFamily: 'bree-headline',
    fontStyle: 'normal',
    fontWeight: '500',
    src: `url(${breeShHeadlingRegular}) format('woff')`
};

export const shuiTheme = createUnifiedTheme({
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                '@font-face': [siemensSans03Font, siemensSans33Font, siemensSans08Font, breeShHeadlineRegularFont],
            },
        },
    },
    ...createBaseThemeOptions({
        typography: {
            ...defaultTypography,
            htmlFontSize: 18,
            fontFamily: 'siemens sans',
            h1: {
                fontSize: 54,
                fontWeight: 500,
                marginBottom: 10,
                fontFamily: 'bree-headline',
            }
        },
        palette: {
            ...palettes.dark,
            primary: {
                main: '#CF4B00',
            },
            secondary: {
                main: '#565a6e',
            },
            error: {
                main: '#E7001D',
            },
            warning: {
                main: '#FFD200',
            },
            info: {
                main: '#34548a',
            },
            success: {
                main: '#009A38',
            },
            background: {
                default: '#1E1E1E',
                paper: '#323232',
            },
            banner: {
                info: '#34548a',
                error: '#8c4351',
                text: '#343b58',
                link: '#565a6e',
            },
            errorBackground: '#8c4351',
            warningBackground: '#8f5e15',
            infoBackground: '#343b58',
            navigation: {
                background: '#141414',
                indicator: '#8f5e15',
                color: '#d5d6db',
                selectedColor: '#ffffff',
            },
        },
    }),
    defaultPageTheme: 'home',
    /* below drives the header colors */
    pageTheme: {
        home: genPageTheme({ colors: ['#141414'], shape: "none" }),
        documentation: genPageTheme({ colors: ['#141414'], shape: "none" }),
        tool: genPageTheme({ colors: ['#141414'], shape: "none" }),
        service: genPageTheme({ colors: ['#141414'], shape: "none" }),
        website: genPageTheme({ colors: ['#141414'], shape: "none" }),
        library: genPageTheme({ colors: ['#141414'], shape: "none" }),
        other: genPageTheme({ colors: ['#141414'], shape: "none" }),
        app: genPageTheme({ colors: ['#141414'], shape: "none" }),
        apis: genPageTheme({ colors: ['#141414'], shape: "none" }),
    }
});